import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../Components/i18n";
import mqtt from "mqtt";


function parseTimestamp(timestamp) {
  try {
    const [datePart, timePart] = timestamp.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute, second);
  } catch (e) {
    // console.log(e);
    return new Date();
  }
}

const OnlineIcon = ({ timestamp }) => {
  //console.log(timestamp, "timestamp");
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    const updateColor = () => {
      const currentTime =
        new Date().getTime() + new Date().getTimezoneOffset() * 60000;
      if (!timestamp) return false; // 🔒 Reject empty/null/undefined
 if(timestamp?.length < 3) return false; 
      const date = parseTimestamp(timestamp);
      if (isNaN(date.getTime())) return false;

      const lastHeartbeat = date.getTime();
      const timeDifference = (currentTime - lastHeartbeat) / 1000; // Convert to seconds

      const isOnline = timeDifference <= 10; // 10 seconds

      setIsOnline(isOnline);
    };

    updateColor();
    const interval = setInterval(updateColor, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <>
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: isOnline ? "#28a745" : "#dc3545",
          boxShadow: isOnline ? "0px 0px 8px #28a745" : "none",
          animation: isOnline ? "pulse 1s infinite" : "none",
          marginBlock: "5px",
        }}
      ></div>
      <style>
        {`
      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #8ec0fc;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        display:flex
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes pulse {
        0% {
          box-shadow: 0 0 5px #28a745;
        }
        50% {
          box-shadow: 0 0 15px #28a745;
        }
        100% {
          box-shadow: 0 0 5px #28a745;
        }
      }
    `}
      </style>
    </>
  );
};
function Devices({ children, toggleLanguage }) {
  const [dataArr, setDataArr] = useState([]);
  const [loading2, setloading2] = useState(true);
  const location = useLocation();

  const [filteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const navigate = useNavigate();
  // const [anyUserSelected, setanyUserSelected] = useState(false);
const fetchdevice = async()=>{
  fetch(`https://api.db2sg.com/esps`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response?.status} ${response?.statusText}`
        );
      }
      return response.json();
    })
    .then((result) => {
     // console.log(result, "result?.data");
      if (result) {
        fetch(`https://db2sg.com/HamitaherApi/user.php`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `HTTP error! Status: ${response?.status} ${response?.statusText}`
              );
            }

            return response.json();
          })
          .then((res) => {
            const updatedData = result?.data?.map((device) => {
              const userWithDevice = res.find((user) => {
                const deviceData =
                  user?.devices && (user?.devices)[device.id];
//console.log("Found device data:", deviceData); // Debugging line
                return deviceData;
              });

              return {
                ...device,
                user: userWithDevice ? userWithDevice.name : "Unknown",
                deviceInfo: userWithDevice ? { ...userWithDevice } : null, // Store device info
              };
            });

            setDataArr(updatedData);
            setloading2(false);
//console.log(updatedData, "Updated data with user info");
          })
          .catch((error) => {
            console.log(error, "Error");
          });
      }
    })
    .catch((error) => console.log(error));
}
  useEffect(() => {
    fetchdevice()
  }, []);
  useEffect(() => {
    const client = mqtt.connect("wss://mqtt.db2sg.com:9001/mqtt"); // your broker
  
    client.on("connect", () => {
      console.log("MQTT connected for heartbeat");
      client.subscribe("#"); // change to your actual topic
    });
  
    client.on("message", (topic, message) => {
      try {
        
        if (!topic.includes("heartbeat")) return;
  
        // if (!data.id || !data.heartbeat) return;
        const deviceId = topic.split("/")[0];
       // console.log("Heartbeat MQTT:", message?.toString(),topic);
  
        setDataArr(prev =>
          prev.map(device =>
            device.id === deviceId
              ? { ...device, heartbeat: message?.toString() } // update only heartbeat
              : device
          )
        );
      } catch (err) {
        console.log("MQTT parse error:", err);
      }
    });
  
    return () => client.end();
  }, []);
  
 
  useEffect(() => {
    const lowercasedSearch = Search.toLowerCase();
    if (lowercasedSearch !== "") {
      const filtered = dataArr.filter((item) => {
        return (
          item?.id?.toLowerCase().includes(lowercasedSearch) ||
          item?.deviceInfo?.name?.toLowerCase().includes(lowercasedSearch) ||
          item?.orgName?.toLowerCase().includes(lowercasedSearch) ||
          item?.deviceName?.toLowerCase().includes(lowercasedSearch) ||
          item?.version?.toLowerCase().includes(lowercasedSearch)
        );
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(dataArr);
    }
  }, [Search, dataArr]);

  // const [showMap, setShowMap] = useState(false);

  const { t } = useTranslation();
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });
  const getValueByKey = (obj, key) => {
    if (!key) return "";
    return key.split(".").reduce((acc, part) => acc?.[part], obj);
  }; 
  const parseInstallationDate = (dateStr) => {
    if (!dateStr) return null;
  
    try {
      const [datePart, timePart] = dateStr.split(" ");
  
      const [day, month, year] = datePart.split("/").map(Number);
      const [hour = 0, minute = 0, second = 0] =
        timePart?.split(":").map(Number) || [];
  
      return new Date(year, month - 1, day, hour, minute, second);
    } catch {
      return null;
    }
  };
  
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;
  
    const sorted = [...filteredData].sort((a, b) => {
      let valA = getValueByKey(a, sortConfig.key);
      let valB = getValueByKey(b, sortConfig.key);
  
      // 🔹 Installation date sorting (DD/MM/YYYY or string date)
      if (sortConfig.key === "installation_date") {
        const dateA = parseInstallationDate(valA);
        const dateB = parseInstallationDate(valB);
      
        if (!dateA || !dateB) return 0;
      
        return sortConfig.direction === "asc"
          ? dateA - dateB
          : dateB - dateA;
      }
      
  
      // 🔹 Null safety
      valA = valA ?? "";
      valB = valB ?? "";
  
      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();
  
      if (strA < strB) return sortConfig.direction === "asc" ? -1 : 1;
      if (strA > strB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  
    return sorted;
  }, [filteredData, sortConfig]);
  

  
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction:
        prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };
  const handleDeleteDevice = (deviceId) => {
    if (!window.confirm("Are you sure you want to delete this device?")) return;
console.log(deviceId)
    fetch(`https://db2sg.com/HamitaherApi/delete.php?user_id='00'&esp_id=${deviceId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response?.status} ${response?.statusText}`
        );
      }

      return response.json();
    })
      .then((res) => {
        console.log(res)
        fetchdevice()
      })
      .catch(console.error);
  };
  return (
    <>
      <SideBar />
      <div className="topbar" style={{ backgroundColor: "#8ec0fc" }}>
        <div className="container-fluid devices_topbar">
          <div className="row d-flex align-items-center justify-content-evenly">
            <div className="col text-center px-3 d-flex flex-start">
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "100%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </span>
            </div>

            <div
              className="col-2 d-flex align-items-center"
              style={{ width: "160px", justifyContent: "space-between" }}
            >
              {/* <button
                onClick={() => setShowMap((prev) => !prev)}
                className="btn"
                style={{
                  background: !anyUserSelected
                    ? "grey"
                    : "linear-gradient(45deg, #000, #000, #000,#000)",
                  color: !anyUserSelected ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              >
                {showMap ? "Show Table" : "Show Map"}
              </button> */}

              <span
                style={{
                  color: "#000",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "100%",
                  marginLeft: "20px",
                }}
              >
                {i18n.language === "en" ? "Hebrew" : "Hebrew"}
              </span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={i18n.language === "he"}
                  onChange={toggleLanguage}
                  name="loading"
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-1 mb-4">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <h5 className="mt-2" style={{ color: "#8ec0fc" }}>
              {t("Devices")}
            </h5>
          </div>
          <div className="col-auto">
            <div className="search-container d-flex align-items-center">
              <input
                value={Search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                style={{
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
                type="text"
                className="search-input"
                placeholder={t("Search")}
              />
            </div>
          </div>
        </div>
      </div>

      {loading2 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <div className="spinner"></div>
        </div>
      ) : (
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <table className="table table-striped table-responsive">
            <thead
              style={{
                position: "sticky",
                top: 0,
                background: "#fff",
                zIndex: 2,
              }}
            >
              <tr
                style={{
                  cursor: "pointer",
                  fontSize: "95%",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                <th
                  style={{ textAlign: "center", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                </th>
                <th
                 onClick={() => handleSort("id")}
                  style={{ textAlign: "center", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                  
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                  <span>{t("Id")}</span>
                  <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "id" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "id" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                      </div>
                </th>
                <th
                onClick={() => handleSort("deviceName")}
                  style={{ paddingLeft: "0px", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                  <span>{t("Device Name")}</span>
                  <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "deviceName" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "deviceName" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                      </div>
                </th>
                <th onClick={() => handleSort("deviceInfo.name")}
                  style={{ paddingLeft: "0px", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                  
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                  <span>{t("User Name")}</span>
                  <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "deviceInfo.name" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "deviceInfo.name" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                  </div>
                </th>
                <th onClick={() => handleSort("installation_date")}
                  style={{ paddingLeft: "0px", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                  
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                  <span>{t("Installation Date")}</span>
                  <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "installation_date" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "installation_date" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                      </div>
                </th>
                <th onClick={() => handleSort("version")}
                  style={{ paddingLeft: "0px", fontSize: "100%" }}
                  scope="col"
                >
                  {" "}
                  
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // vertical centering
                        justifyContent: "center", // horizontal centering
                        gap: "4px",
                      }}
                    >
                  <span>{t("Version")}</span>
                  <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: "10px",
                        }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "version" &&
                              sortConfig.direction === "asc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▲
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "8px",
                            color:
                              sortConfig.key === "version" &&
                              sortConfig.direction === "desc"
                                ? "#333"
                                : "#888",
                          }}
                        >
                          ▼
                        </span>
                      </span>
                      </div>
                </th>
                {localStorage.getItem("usertype") === "admin"|| localStorage.getItem("usertype") === "sitemanager" ?
                <th>
                  Delete
                </th>
                :null}
              </tr>
            </thead>
            <tbody>
              {sortedData
                .filter((i) => {
                  if (i.id === "test") return false;
                  if (i.id === "undefined") return false;
                  const isDevicesPage = location.state?.role === "device";

                  // If on "devices" page, apply online + role check
                  if (isDevicesPage) {
                    if (!i.heartbeat) return false;
                    const currentTime =
                      new Date().getTime() +
                      new Date().getTimezoneOffset() * 60000;
                    const date = parseTimestamp(i.heartbeat);
                    if (isNaN(date.getTime())) return false;
                    const lastHeartbeat = date.getTime();
                    const timeDifference = (currentTime - lastHeartbeat) / 1000; // in seconds
                    const isOnline = timeDifference <= 10;

                    if (!isOnline) return false;
                  }

                  return true;
                })
                .map((i, index) => (
                  <tr
                    onClick={() => {
                      if ((i?.deviceInfo?.devices || "{}")[i.id]?.provisioned) {
                        navigate("/devicesdata", {
                          state: {
                            deviceName: i.deviceName,
                            enabled: (i?.deviceInfo?.devices || "{}")[i.id]
                              ?.enabled,
                            esp_id: i.id,
                            provisioned: (i?.deviceInfo?.devices || "{}")[i.id]
                              ?.provisioned,
                            user: i.deviceInfo,
                          },
                        });
                      } else {
                        alert(
                          "Device not provisioned: First provision it from the app"
                        );
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "95%",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                    key={index}
                  >
                    <td
                      style={{
                        fontSize: "100%",
                        color: "#000",
                        justifyContent: "center",
                        paddingTop: "auto",
                      }}
                    >
                      <OnlineIcon timestamp={i.heartbeat}></OnlineIcon>
                    </td>
                    <td
                      style={{
                        paddingLeft: "0px",
                        fontSize: "100%",
                        color: "#000",
                      }}
                    >
                      {i.id}
                    </td>
                    <td
                      style={{
                        paddingLeft: "0px",
                        fontSize: "100%",
                        color: "grey",
                      }}
                    >
                      {i.deviceName}
                    </td>
                    <td
                      style={{
                        paddingLeft: "0px",
                        fontSize: "100%",
                        color: "grey",
                      }}
                    >
                      {i?.deviceInfo?.name}
                    </td>
                    <td
                      style={{
                        paddingLeft: "0px",
                        fontSize: "100%",
                        color: "grey",
                      }}
                    >
                      {i.installation_date}
                    </td>
                    <td
                      style={{
                        paddingLeft: "0px",
                        fontSize: "100%",
                        color: "grey",
                      }}
                    >
                      {i.version}
                    </td>
                    {localStorage.getItem("usertype") === "admin"|| localStorage.getItem("usertype") === "sitemanager" ?
                    <td>
                    <img
        src="assets/delete.png"
        width={20}
        height={20}
        style={{ cursor: "pointer" }}
        onClick={(e) => {e.preventDefault();e.stopPropagation(); handleDeleteDevice(i.id)}}
        alt="Delete"
      />
                    </td>
                    :null}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
      <style>
        {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #8ec0fc;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0% {
              box-shadow: 0 0 5px #28a745;
            }
            50% {
              box-shadow: 0 0 15px #28a745;
            }
            100% {
              box-shadow: 0 0 5px #28a745;
            }
          }
        `}
      </style>
    </>
  );
}

export default Devices;
